import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail, Clock } from 'lucide-react';

const CTASection = ({ onOpenModal }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#2B0A12] via-[#3D1C24] to-[#2B0A12] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#FFB400] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D72638] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-[#F1F1F1] mb-6">
          Ready to Protect Your Brand?
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Schedule a free consultation with our IP attorneys and take the first step toward securing your intellectual property.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Button
            size="lg"
            onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - CTA Section')}
            className="bg-[#FFB400] hover:bg-[#e5a200] text-[#2B0A12] font-semibold text-lg px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Start Trademark Registration
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => onOpenModal && onOpenModal('Discuss with Attorney - CTA Section')}
            className="border-2 border-[#F1F1F1] text-[#F1F1F1] hover:bg-white hover:text-[#2B0A12] font-semibold text-lg px-8 py-6 rounded-lg transition-all duration-300 hover:scale-105"
          >
            Discuss with Attorney
          </Button>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-[#F1F1F1]">
          <div className="flex items-center space-x-2">
            <Phone className="h-5 w-5 text-[#FFB400]" />
            <span className="text-lg">+1 (877) 317-1184</span>
          </div>
          <div className="flex items-center space-x-2">
            <Mail className="h-5 w-5 text-[#FFB400]" />
            <span className="text-lg">info@trademarkessential.com</span>
          </div>
        </div>

        <p className="text-gray-400 mt-8">
          No obligation. Free initial consultation. Transparent pricing.
        </p>
      </div>
    </section>
  );
};

export default CTASection;